/**
 * created by li si yi
 * 基础数据-资源库管理
 */
import React, {Component} from 'react';
import {message, Tabs, Modal, Popconfirm, Button, Radio} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {uuid} from "../../../utils";

const {TabPane} = Tabs;

export default class ResourceSettings extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            // 选项卡数据
            tabBarList: [
                {
                    key: '0',
                    // name: '资源重新发布',
                    btnTitle: '重新发布',
                    columns: [
                        {
                            title: 'ID',
                            dataIndex: 'serial',
                            key: 'serial',
                            width: 100,
                            ellipsis: true,
                            render: (text, record, index) => `${index + 1}`
                        },
                        {
                            title: '索引库名称',
                            dataIndex: 'indexTitle',
                            ellipsis: true,
                            key: 'indexTitle',
                            width: 600,
                            render: (text, record) => {
                                return (
                                    <span style={{cursor: 'pointer'}}>{record}</span>
                                )
                            }
                        },
                        {
                            title: '操作',
                            dataIndex: 'action',
                            width: 100,
                            render: (text, record) => {
                                return (
                                    <>
                                        <Popconfirm
                                            title={`确定删除索引库：${record}？`}
                                            onConfirm={() => {
                                                this.deleteData(record)
                                            }}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                        <span style={{
                                            padding: '3px 10px',
                                            background: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                            color: '#fff',
                                            borderRadius: 5,
                                            marginRight: 10,
                                            cursor: 'pointer'
                                        }}>删除</span>
                                        </Popconfirm>
                                    </>
                                )
                            }
                        },
                    ],// 资源重新发布
                }
            ],
            thisTabKey: '0',// 选项卡当前选中项
            params: {
                page: {
                    start: 1,// 分页
                    size: 10,
                },
            },
            thisBtn: '',
            thisColumns: [],// 当前表头
            total: 0,
            dataSource: [],// 表格数据
            treeData: [],// 树类型数据
            selectedKeys: [],// 选中
            visible: false, // 弹框
            modalContent: {},// 弹框内容
            radioValue: 'story,picture,video,other_file,audio',// 单选选中
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div style={{background: '#fff', borderRadius: '5px', maxHeight: 'calc(100vh - 100px)', margin: 15}}>
                {/*选项卡*/}
                {/*{this.renderTabBar()}*/}
                {/*内容*/}
                {this.renderTable()}
                {/*消息弹框*/}
                {this.renderModal()}
            </div>
        )
    }

    // 选项卡
    // renderTabBar = () => {
    //     return (
    //         <div className={'tabBarStyle'}>
    //             <Tabs defaultActiveKey="0">
    //                 {
    //                     this.state.tabBarList.map((item) => {
    //                         return (
    //                             <TabPane tab={item.name} key={item.key}
    //                                      style={{backgroundColor: '#fff', color: '#0050B3'}}/>
    //                         )
    //                     })
    //                 }
    //             </Tabs>
    //             <style>
    //                 {`
    //                     .tabBarStyle{
    //                         display:none;
    //                     }
    //                     .tabBarStyle .ant-tabs-nav{
    //                          padding-left: 16px;
    //                          padding-top:5px;
    //                      }
    //                 `}
    //             </style>
    //         </div>
    //     )
    // };
    // 内容部分
    renderTable = () => {
        let {thisTabKey, dataSource, tabBarList} = this.state;
        tabBarList.forEach(item => {
            if (thisTabKey === item.key) {
                this.state.thisColumns = item.columns;
                this.state.thisBtn = item.btnTitle;
            }
        });
        return (
            <div style={{padding: '24px 32px'}}>
                <Button type={'primary'} style={{marginBottom: 24}} onClick={() => {
                    this.showModal();
                }}>{this.state.thisBtn}</Button>
                <Scrollbars autoHeight autoHeightMax={ 'calc(100vh - 340px)'}>
                    <BaseTable rowKey="id" dataSource={dataSource}
                               columns={this.state.thisColumns}
                               pagination={false}/>
                </Scrollbars>
            </div>
        )
    };
    // 资源重新发布弹窗
    renderModal = () => {
        let {visible} = this.state;
        // let values = ['story', 'picture', 'video', 'other_file', 'audio'];
        let radioAll = [
            {
                title: '全部',
                value: 'story,picture,video,other_file,audio'
            },
            {
                title: '稿件库',
                value: 'story',
            },
            {
                title: '图片库',
                value: 'picture',
            },
            {
                title: '视频库',
                value: 'video',
            },
            {
                title: '其他',
                value: 'other_file',
            },
            {
                title: '音频库',
                value: 'audio',
            }
        ];
        // if (!this.state.radioValue) {
        //     this.state.radioValue = values.join(',');
        // }
        return (
            <div className={'modalStyle'}>
                <Modal
                    title={"重新发布"}
                    width={600}
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.onCancel}
                    centered={true}
                    okText="确定"
                    cancelText="取消"
                    maskClosable={false}
                >
                    <div>
                        <Radio.Group onChange={this.radioOnChange} value={this.state.radioValue}>
                            {
                                radioAll.map((item, index) => {
                                    return (
                                        <Radio value={item.value} key={index}>{item.title}</Radio>
                                    )
                                })
                            }
                        </Radio.Group>
                    </div>
                </Modal>
            </div>
        )
    };
    // 单选改变
    radioOnChange = e => {
        this.setState({
            radioValue: e.target.value,
        });
    };
    // 重新发布
    redistribution = () => {
        let params = {indexNames: this.state.radioValue};
        this.request({
            url: '/search-server/search/dataRebuildByMongo',
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success('重新发布成功', 1, () => {
                        this.getData()
                    });
                }
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 删除
    deleteData = (record) => {
        message.destroy();
        let params = {
            indexNames: record
        };
        this.request({
            url: '/search-server/search/deleteIndex',
            body: params,
            callBack: (res) => {
                console.log(res);
                if (res) {
                    message.success('删除成功', 1, () => {
                        this.getData()
                    });
                }
            }
        })
    };
    // 获取表数据
    getData = () => {
        message.destroy();
        this.request({
            url: '/search-server/search/getIndexList',
            callBack: (res) => {
                let dataSource = [];
                if (res) {
                    dataSource = res;
                }
                this.setState({dataSource})
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 弹框
    showModal = () => {
        this.setState({
            visible: true,
            radioValue: 'story,picture,video,other_file,audio',
        });
    };
    // 确认发布
    handleOk = () => {
        this.setState({
            visible: false,
        });
        this.redistribution();
    };
    onCancel = () => {
        this.setState({
            visible: false,
        });
    }
};

ResourceSettings.defaultProps = {};
ResourceSettings.propTypes = {};